const typography = {
  fontFamily: "'Inter', sans-serif",
  fontSize: 14,
  h1: {
    fontSize: 24,
    lineHeight: 32 / 24,
    fontWeight: 700,
  },
  h2: {
    fontSize: 20,
    fontWeight: 700,
  },
  h3: {
    fontSize: 18,
    fontWeight: 700,
  },
  h4: {
    fontSize: 16,
    fontWeight: 600,
  },
  h5: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 22 / 14,
  },
  h6: undefined,
  body1: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 22 / 14,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 22 / 14,
    color: '#666',
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 20 / 12,
    color: '#666',
  },
}

export default typography
